import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Menu from "../components/Menu/Menu";

export default function PrivateRouter() {
  const token = localStorage.getItem('token');

  return token ? (
    <>
      <Menu />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" replace />
  );
}
